import { CACHE_TAG } from 'enums';

import apiRoutes from 'router/routes/ApiRoutes';

import { apiContainer } from 'store';

import { selectResultsFromResponse } from 'utils/objects';
import { createTag } from 'utils/rtkQuery';

export const poolsChoicesApi = apiContainer.injectEndpoints({
  endpoints: builder => ({
    getPoolsChoices: builder.query({
      query: params => ({
        url: apiRoutes.poolsChoicesPath(),
        method: 'GET',
        params,
      }),
      transformResponse: selectResultsFromResponse,
      providesTags: result => createTag.index(result, CACHE_TAG.poolChoice),
    }),
  }),
});

export const { useGetPoolsChoicesQuery } = poolsChoicesApi;
